// Thin wrapper around the shared `apiFetch` helper, hard-coding the
// `app: 'mobile'` flag so each call lands on the mobile sub-app
// (`VITE_MOBILE_API_BASE`, which CI sets to
// `${LIGHTNING_API_BASE}/api/mobile`).
//
// Mobile mirrors lightning's HTTP surface exactly — /scans, /api/jobs/*,
// /api/batches/*, /api/settings/* — because it is the same product for
// phone-captured scans. Everything under `web/src/mobile` therefore calls
// `mobileFetch` with the same paths the merch code passes to `apiFetch`.

import { apiFetch, MOBILE_API_BASE } from '../utils/api';
import type { ApiFetchInit } from '../utils/api';

export { MOBILE_API_BASE };

/** `apiFetch` pinned to the mobile sub-app. */
export function mobileFetch(
  input: string,
  init: Omit<ApiFetchInit, 'app'> = {}
): Promise<Response> {
  return apiFetch(input, { ...init, app: 'mobile' });
}
